<template>
    <div class="checkout">
        <div class="app-container pa-0 pa-sm-4">
            <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
            <v-row class="mx-0">
                <v-col cols="12" lg="8">
                    <v-card outlined>
                        <v-card-title class="justify-center font-weight-bold subtitle-2 text-uppercase pa-4" v-if="metaData.header">
                            {{ metaData.header }}
                        </v-card-title>
                        <v-card-text v-if="basketItemsCount > 0">
                            <v-form
                                ref="form"
                                v-model="isValidOrder"
                            >
                                <v-row сlass="d-flex flex-wrap grey--text text--lighten-2">
                                    <v-col cols="12" class="py-1 py-sm-3">
                                        <span class="text-body-1 grey--text text--darken-3 font-weight-bold">{{ $t('contactsInfo') }}</span>
                                    </v-col>
                                    <v-col cols="12" sm="4" class="py-0">
                                        <v-text-field
                                            :label="$t('firstName')"
                                            color="orange lighten-2"
                                            v-model="formData.name"
                                            :rules="rules.text"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" class="py-0">
                                        <v-text-field
                                            :label="$t('lastName')"
                                            color="orange lighten-2"
                                            v-model="formData.lastName"
                                            :rules="rules.text"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" class="py-0">
                                        <v-text-field
                                            :label="$t('company')"
                                            color="orange lighten-2"
                                            v-model="formData.companyName"
                                            :disabled="isUserLoggedIn"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" class="py-0">
                                        <v-text-field
                                            label="E-mail"
                                            color="orange lighten-2"
                                            v-model="formData.email"
                                            :rules="rules.email"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" class="py-0">
                                        <v-text-field
                                            :label="$t('telephone')"
                                            color="orange lighten-2"
                                            v-mask="'+38 ### ###-####'"
                                            v-model="formData.phone"
                                            :rules="rules.phone"
                                            required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-divider class="my-1"></v-divider>
                                <v-row class="d-flex flex-wrap">
                                    <order-list></order-list>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-text v-else>
                            <div class="title py-8 text-center">{{ $t('basketEmpty') }}</div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="4">
                    <order-amount :valid="isValidOrder" @click-buy="send" class="order-amount"></order-amount>
                </v-col>
            </v-row>
        </div>

        <liqpay-form
            v-if="paymentData"
            :data="paymentData.data"
            :signature="paymentData.signature"
        ></liqpay-form>

        <snack-general :snack-data="snackData"></snack-general>
    </div>
</template>

<script>
import Breadcrumbs from "../../../app-front/components/breadcrumbs/Breadcrumbs";
import LiqpayForm from "./LiqpayForm";
import OrderAmount from "./Amount/OrderAmount";
import OrderList from "./OrderList";

import AppBreadcrumbs from "../../../app-front/mixins/AppBreadcrumbs";
import OrderDataProvider from "../../../app-front/mixins/OrderDataProvider";
import Auth from "../../../app-front/mixins/Auth";
import AddToBasket from "../../../app-front/mixins/AddToBasket";
import NoLoginBasket from "../../../app-front/mixins/NoLoginBasket";
import SnackGeneral from "../../../app-front/components/snacks/SnackGeneral";
import BasketService from "../../../app-front/services/api/BasketService";
import OrderService from "../../../app-front/services/api/OrderService";

export default {
    name: "Checkout",
    components: {
        Breadcrumbs,
        LiqpayForm,
        OrderAmount,
        OrderList,
        SnackGeneral
    },
    mixins: [
        AddToBasket,
        AppBreadcrumbs,
        Auth,
        NoLoginBasket,
        OrderDataProvider
    ],
    data() {
        return {
            metaUrl: '/checkout',
            breadcrumbsData: {
                page: 'checkoutPage',
                data:{}
            },
            formData: {},
            isValidOrder: false,
            loading: false,
            paymentData: null,
            rules: {
                email: [
                    v => !!v || this.$t('requiredField'),
                    v => /.+@.+/.test(v) || this.$t('emailInvalid'),
                ],
                phone: [
                    v => !!v || this.$t('requiredField'),
                    v => /^(\+\d{2}).*?\s.*?(\d{3}).*?\s.*?(\d{3}).*?-.*?(\d{4})$/.test(v) || this.$t('phoneInvalid'),

                ],
                text: [
                    v => !!v || this.$t('requiredField'),
                ],
            },
            snackData: {
                isOpen: false,
                color: '',
                text: ''
            },
        }
    },
    computed: {
        basketItemsCount() {
            return this.isUserLoggedIn ? this.addToBasketCount : this.noLoginBasketCount ;
        },
        sendData() {
            return !this.$route.query.sellerID ? this.orderSendData : this.orderSendData.filter(order => {
                return order.sellerID === parseInt(this.$route.query.sellerID);
            });
        }
    },
    methods: {
        send() {
            if(window.fbq) {
                window.fbq('track', 'Purchase', {
                    value: this.sendData.reduce((sum, item) => {
                        const curValue = item.priceWithDiscount ? item.priceWithDiscount : item.priceSummary;
                        return sum + curValue;
                    }, 0),
                    currency: 'UAH'
                });
            }
            const sendData = {
                customer: this.formData,
                orders: this.sendData
            };
            BasketService.setLocale(this.$store.state.language.appLanguage);
            BasketService.createBasketOrder(sendData)
                .then(res => {
                    if (res.data.payment.data) {
                        this.setStorageResponseData(res.data);
                        this.paymentData = res.data.payment.data;
                    } else {
                        if (res.data.success.length) {
                            this.snackHandle(this.$t('orderSuccess'), 'main--black', true);
                            this.successHandle(res.data);
                            this.$router.push({ name: 'checkoutSuccess' });
                        } else if (res.data.errors.length) {
                            this.snackHandle(this.$t('orderError'), 'error', true);
                            console.log(res.data.errors);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getCreatedOrderInfo() {
            this.loading = true;
            OrderService.getCreatedOrderInfo({ groupID: this.responseDataGroupID, userID: this.responseDataUserID })
                .then(res => {
                    console.log(res)
                    if (res.data.success && res.data.success.length) {
                        this.successHandle(res.data);
                        this.clearStorageResponseData();

                        if (res.data.isCanceled) {
                            this.snackHandle(this.createErrorSnackText(res.data.success), 'main--black', true);
                        } else {
                            this.$router.push({ name: 'checkoutSuccess' });
                        }
                    }
                })
                .catch(console.log)
                .finally(() => {
                    this.loading = false;
                })
        },
        successHandle(resData) {
            this.setOrderResponseData(resData);

            if(resData.success && resData.success.length) {
                this.setOrderResponseSuccessData(resData.success);
                this.setProductIDsFromResponse(resData.success);
                this.responseProductIDs.forEach(this.deleteProductFromNoLoginBasket, this);
                this.responseDataSuccessHandle();
            }

            this.resetOrderDialog();
        },
        createErrorSnackText(orders) {
            const products = orders.flatMap(order => order.products);
            const getProducts = (isSelf) => products
                .filter(product => isSelf ? product.selfShipment : !product.selfShipment)
                .map(product => product.name)
                .join(', ');

            const selfShipmentProducts = getProducts(true);
            const others = getProducts(false);

            return `
                ${ this.$t('allProductsNotCompleted') }.
                ${ this.$t('productsAreBoughtOnline') }: ${ selfShipmentProducts }.
                ${ others && (this.$t('productsPurchasedApp') + ': ' + others) }.
            `;
        },
        snackHandle(text, color, isOpen) {
            this.snackData.color = color;
            this.snackData.text = text;
            this.snackData.isOpen = isOpen;
        },
    },
    created() {
        if (this.isUserLoggedIn) {
            this.formData = this.orderBuyerData;
        }
    },
    beforeMount() {
        if (this.orderResponseData) {
            this.getCreatedOrderInfo();
        } else {
            if(!this.inProcessProducts.length) {
                this.$router.push({name: "Basket"});
            }
            if (window.fbq) window.fbq('track', 'InitiateCheckout');
        }
    },
    watch: {
        inProcessProducts: {
            handler() {
                this.backupSet();
            },
            deep: true
        },
    }
}
</script>

<style scoped>

</style>
